// tslint:disable: max-line-length
import { Injectable } from '@angular/core';

/**
 * @deprecated å·²åºé¤
 */
@Injectable()
class FilterConditionService {
}
export { FilterConditionService };
